import { render, staticRenderFns } from "./product-details-sidebar.vue?vue&type=template&id=4ab15c32&scoped=true&"
import script from "./product-details-sidebar.vue?vue&type=script&lang=js&"
export * from "./product-details-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./product-details-sidebar.vue?vue&type=style&index=0&id=4ab15c32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab15c32",
  null
  
)

export default component.exports